import React, { Fragment } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import {
  Box,
  Grid,
  Card,
  CardContent,
  colors,
  Icon,
  Typography,
  Button,
  makeStyles
} from '@material-ui/core';

import { RiAlarmWarningLine } from "react-icons/ri";
import { BsBuilding } from "react-icons/bs";
import { AiOutlineFileProtect } from "react-icons/ai";
import { IoMdCart } from "react-icons/io";
import { MdManageAccounts } from "react-icons/md";
import { Activity } from 'react-feather';
import { GiHandTruck } from "react-icons/gi";
import { BsPrinter } from "react-icons/bs";
import { AiFillTool } from "react-icons/ai";
import { GoTools } from "react-icons/go";
import { BsCurrencyExchange } from "react-icons/bs";
import { IoIosCalculator } from "react-icons/io";
import { FaClipboardList } from "react-icons/fa";
import { FaFileImport } from "react-icons/fa";

const items = [
  {
    href: '/mgt/occurrences',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/units',
    icon: BsBuilding,
    title: 'Unidades',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/contracts',
    icon: AiOutlineFileProtect,
    title: 'Contratos',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/productslpu',
    icon: FaClipboardList,
    title: 'LPU',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/stocks',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/reports',
    icon: BsPrinter,
    title: 'Relatórios',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/imports',
    icon: FaFileImport,
    title: 'Importação',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/mgt/occurrences',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/units',
    icon: BsBuilding,
    title: 'Unidades',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/contracts',
    icon: AiOutlineFileProtect,
    title: 'Contratos',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/stocks',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/mgt/reports',
    icon: BsPrinter,
    title: 'Relatórios',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[400],
    profile: 'AAD'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mgt/occurrences',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/budgets',
    icon: IoIosCalculator,
    title: 'Orçamentos',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/units',
    icon: BsBuilding,
    title: 'Unidades',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/contracts',
    icon: AiOutlineFileProtect,
    title: 'Contratos',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/products',
    icon: IoMdCart,
    title: 'Produtos',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/productslpu',
    icon: FaClipboardList,
    title: 'LPU',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/stocks',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/others',
    icon: GoTools,
    title: 'Configurações',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/reports',
    icon: BsPrinter,
    title: 'Relatórios',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/mgt/imports',
    icon: FaFileImport,
    title: 'Importação',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/fin/main',
    icon: BsCurrencyExchange,
    title: 'Financeiro',
    color: colors.green[600],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    width: 120,
    height: 120
  },
  grid: {
    marginTop: 10
  },
  card: {
    height: 200,
    minWidth: 200
  },
  button: {
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    width: '100%'
  }
}));

const Results = ({ className }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box>
        <Grid container
          className={classes.grid}
          spacing={2}
          direction="row"
          justifyContent={(screen.width <= 480) ? "center" : "flex-start"}
        >

          {items.map((value) => (

            <Grid item key={value.href} hidden={localStorage.getItem('profile') != value.profile}  >

              <Button
                className={classes.button}
                component={RouterLink}
                to={value.href}
              >

                <Card className={classes.card}>

                  <CardContent>

                    <Box alignItems="center"
                      display="flex"
                      flexDirection="column"
                    >

                      {<Icon className={classes.avatar} component={value.icon} style={{ color: value.color }} ></Icon>}

                      <Typography align="center"
                        color="primary"
                        gutterBottom
                        variant="h4"
                      >
                        {value.title}
                      </Typography>
                    </Box>

                  </CardContent>

                </Card>

              </Button>

            </Grid>

          ))}


        </Grid>

      </Box>

    </Fragment >
  );
};

export default Results;